import { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { PageContext } from '../../../contexts/page-context'
import { gnarSpec } from '../../../lib/tracking/gnar'
import { ButtonCta } from '../../ui-lib/button'
import { ExternalLink } from '../../ui-lib/link'

import styles from './company-announcement.module.scss'
import { useBannerShow } from '../../../lib/hooks'

const BANNER_URL = 'https://www.grammarly.com/blog/company/grammarly-to-acquire-superhuman'
const BANNER_ID = 'Company Announcement Jul 30, 2025'

export const CompanyAnnouncementBanner = () => {
  const { pageId, slug } = useContext(PageContext)

  useBannerShow(true, BANNER_ID, BANNER_URL)

  return (
    <aside className={styles.banner}>
      <ExternalLink
        className={styles.bannerLink}
        target="_blank"
        href={BANNER_URL}
        onClick={() => {
          void gnarSpec.bannerClick(BANNER_ID, pageId, slug, BANNER_URL)
        }}
      >
        <FormattedMessage
          id="banner.companyAnnouncement.copy"
          description="Banner text announcing Grammarly's acquisition of Superhuman"
          defaultMessage="Grammarly to acquire Superhuman"
        />
        <ButtonCta
          className={styles.bannerButton}
          text={
            <FormattedMessage
              id="global.uiAction.learnMore"
              description="Text for CTA that prompts user to learn more by following a link or taking some other action"
              defaultMessage="Learn More"
            />
          }
          showArrow
          padding="compact"
        />
      </ExternalLink>
    </aside>
  )
}
